'use strict'
// module.exports = '/htdocs2/desarrollo/mcastro/posventa-rol-cliente/'
console.log(process.env)
module.exports = {
  NODE_ENV: '"production"',
  STATIC_PATH_PREFIX: '"'+process.env.VUE_APP_rutaProduccion+'"', // Cambiar build.assetsPublicPath en index.js
  API_PATH: process.env.VUE_APP_API_PATH,
  CUPE_PATH: process.env.VUE_APP_CUPE_PATH
}
